
import axios from "axios";
import { GET_INVESTIGATION_FAIL, GET_INVESTIGATION_REQUEST, GET_INVESTIGATION_SUCCESS } from "../constants/DIvestigation";
import { baseUrl } from "./baseUrl";

export const getInvInvestigation = (patient) => async (dispatch) => {
    try {
        dispatch({
            type: GET_INVESTIGATION_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "Application/json",
                "Authorization": "Bearer " + window.atob(JSON.parse(localStorage.getItem('md_btn_mi_sas'))),
            },
        };
        const { data } = await axios.get(
            `${baseUrl}/diagnostic_investigation?patient=${patient}`,
            config
        );

        dispatch({
            type: GET_INVESTIGATION_SUCCESS,
            payload: data,
        });

    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: GET_INVESTIGATION_FAIL,
            payload: message,
        });

    }
};


